var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "camera-acquisition" }, [
    _vm._m(0),
    _c("div", { staticClass: "overview-list flex-between" }, [
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(1),
        _c(
          "div",
          { staticStyle: { transform: "translateY(-15px)" } },
          [
            _c("CountAnimation", {
              staticClass: "count-bold",
              attrs: { "end-val": _vm.cameraPartInfo.faceCount },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(2),
        _c("div", { staticStyle: { transform: "translateY(-15px)" } }, [
          _c(
            "div",
            { staticClass: "count-bold" },
            [
              _c("CountAnimation", {
                attrs: {
                  "end-val": Number(_vm.dataSource.coverageRate),
                  attr: { decimals: 2 },
                },
              }),
              _vm._v("\n          %\n        "),
            ],
            1
          ),
          _c("div", { staticStyle: { margin: "5px 0" } }, [
            _vm._v("\n          已抓拍学生\n          "),
            _c(
              "span",
              { staticStyle: { color: "#fa6c3d", "font-weight": "bold" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.dataSource.cameraStudentFaceCount) +
                    "\n          "
                ),
              ]
            ),
            _vm._v("\n          ｜ 人脸录入数\n          "),
            _c(
              "span",
              { staticStyle: { color: "#fa6c3d", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.dataSource.studentFaceCount))]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(3),
        _c(
          "div",
          { staticStyle: { transform: "translateY(-15px)" } },
          [
            _c("CountAnimation", {
              staticClass: "count-bold",
              attrs: {
                "end-val": _vm.cameraPartInfo.avgFaceCount,
                attr: { decimals: 2 },
              },
            }),
            _vm._v("\n        张\n      "),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(4),
        _c(
          "div",
          { staticStyle: { transform: "translateY(-15px)" } },
          [
            _c("CountAnimation", {
              staticClass: "count-bold",
              attrs: {
                "end-val": _vm.cameraPartInfo.avgStudentDayFaceCount,
                attr: { decimals: 2 },
              },
            }),
            _vm._v("\n        张\n      "),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "overview-list-item" }, [
        _vm._m(5),
        _c("div", { staticStyle: { transform: "translateY(-15px)" } }, [
          _c(
            "span",
            [
              _vm._v("\n          在线\n          "),
              _c("CountAnimation", {
                staticClass: "count-bold",
                staticStyle: { color: "#3fa3f5" },
                attrs: { "end-val": _vm.cameraRunInfo.onlineCount },
              }),
              _vm._v("\n          台\n        "),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: { "margin-left": "15px" } },
            [
              _vm._v("\n          离线\n          "),
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": _vm.cameraRunInfo.offlineCount },
              }),
              _vm._v("\n          台\n        "),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex-align-center",
        staticStyle: { "margin-bottom": "20px" },
      },
      [
        _c("img", {
          staticStyle: { width: "24px", height: "22px", "margin-right": "5px" },
          attrs: {
            src: require("@/assets/imgs/school/monthRecord/camera.png"),
            alt: "",
          },
        }),
        _c("div", { staticClass: "record-title" }, [_vm._v("相机采集数据")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("本月情绪识别次数")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/collectCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("学生抓拍覆盖率")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/cameraCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("平均全校每日照片采集量")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/pictureCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("平均每生每日照片采集量")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/figureBlue.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("相机运行情况")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/runCircle.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }